import { Device } from "@capacitor/device";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Sentry } from "../utils/sentry";

async function generateDeviceId(): Promise<string> {
  const deviceInfo = await Device.getId();

  if (!deviceInfo.identifier) {
    Sentry.captureMessage(
      "Capacitor did not return a device ID. Generating random UUID.",
    );
    return crypto.randomUUID();
  }

  return deviceInfo.identifier;
}

export const useDeviceIdQuery = (): UseQueryResult<string> =>
  useQuery({
    queryKey: ["deviceId"],
    queryFn: generateDeviceId,
    gcTime: Infinity,
    staleTime: Infinity,
  });
